// frontend/src/api/client.js

// Base URL de l'API Django
// - PROD (polyglow.fr) : même origin => BASE="" => appels en "/api/..." => pas de CORS
// - DEV (local) : mettre REACT_APP_API_BASE_URL=http://localhost:8000
const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

// Récupération des tokens depuis le localStorage
function getAccess() {
  return (
    localStorage.getItem("accessToken") ||
    localStorage.getItem("access") ||
    ""
  );
}

function getRefresh() {
  return (
    localStorage.getItem("refreshToken") ||
    localStorage.getItem("refresh") ||
    ""
  );
}

// Fonction bas niveau qui fait un appel fetch + gestion du refresh
async function request(path, options = {}) {
  const url = `${BASE}${path}`;

  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  // Injecter l'access token si disponible
  const access = getAccess();
  if (access) {
    headers.Authorization = `Bearer ${access}`;
  }

  let res = await fetch(url, { ...options, headers });

  // Si ce n'est pas un 401 → on renvoie tel quel
  if (res.status !== 401) {
    return res;
  }

  // 401 → on tente un refresh
  const refreshTok = getRefresh();
  if (!refreshTok) {
    return res;
  }

  const r = await fetch(`${BASE}/api/auth/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh: refreshTok }),
  });

  if (!r.ok) {
    return res; // refresh impossible → on laisse l'erreur initiale
  }

  const data = await r.json();

  // Mise à jour des tokens
  if (data.access) {
    localStorage.setItem("access", data.access);
    localStorage.setItem("accessToken", data.access);
    headers.Authorization = `Bearer ${data.access}`;
  }
  if (data.refresh) {
    localStorage.setItem("refresh", data.refresh);
    localStorage.setItem("refreshToken", data.refresh);
  }

  // On rejoue la requête avec le nouveau token
  res = await fetch(url, { ...options, headers });
  return res;
}

// Petit helper façon axios: api.get, api.post, api.patch...
function api(path, options) {
  return request(path, options);
}

api.get = (path, options = {}) => request(path, { ...options, method: "GET" });

api.post = (path, body = {}, options = {}) =>
  request(path, {
    ...options,
    method: "POST",
    body: JSON.stringify(body),
  });

api.patch = (path, body = {}, options = {}) =>
  request(path, {
    ...options,
    method: "PATCH",
    body: JSON.stringify(body),
  });

api.delete = (path, options = {}) =>
  request(path, { ...options, method: "DELETE" });

export default api;
export { api, BASE };
